// Owner-approved published card IDs only. All copy/images still come from the
// existing page translations/assets; this does not import or activate inventory.
const publishedIds = new Set(['1', '2', '3', '4', '5']);

export const publishedTourCards = () => [...publishedIds].map(id => ({
  id, highlights: [], included: [], excluded: [],
}));

export const usableTourCards = (data) => {
  if (!Array.isArray(data)) return publishedTourCards();
  const seen = new Set();
  const cards = data.filter(card => {
    if (!card || !publishedIds.has(card.id) || seen.has(card.id)) return false;
    if (!Array.isArray(card.highlights) || !Array.isArray(card.included) || !Array.isArray(card.excluded)) return false;
    seen.add(card.id);
    return true;
  });
  return cards.length ? cards : publishedTourCards();
};